import type { Observable } from 'rxjs';
import type {
  RegisterUserResult,
  UpdateRegisteredUserPayload,
} from '../models/register-user.model';

export abstract class UpdateRegisteredUserPort {
  abstract update(payload: UpdateRegisteredUserPayload, bearerToken: string): Observable<RegisterUserResult>;
}
